export default __webpack_public_path__ + "static/media/israelscreen.a68e5389.png";